export const initialState = {
  channels: {
    published: [],
    subscribed: [],
  },
}

